module.exports = __webpack_public_path__ + "img/hosea-williams.ccc6fbf4.png";